// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MaterialTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MaterialTypesQuery = { __typename?: 'Query', materialTypes: Array<{ __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string }> };


export const MaterialTypesDocument = gql`
    query MaterialTypes {
  materialTypes {
    code
    name
  }
}
    `;

/**
 * __useMaterialTypesQuery__
 *
 * To run a query within a React component, call `useMaterialTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaterialTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MaterialTypesQuery, MaterialTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialTypesQuery, MaterialTypesQueryVariables>(MaterialTypesDocument, options);
      }
export function useMaterialTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialTypesQuery, MaterialTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialTypesQuery, MaterialTypesQueryVariables>(MaterialTypesDocument, options);
        }
export function useMaterialTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialTypesQuery, MaterialTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialTypesQuery, MaterialTypesQueryVariables>(MaterialTypesDocument, options);
        }
export type MaterialTypesQueryHookResult = ReturnType<typeof useMaterialTypesQuery>;
export type MaterialTypesLazyQueryHookResult = ReturnType<typeof useMaterialTypesLazyQuery>;
export type MaterialTypesSuspenseQueryHookResult = ReturnType<typeof useMaterialTypesSuspenseQuery>;
export type MaterialTypesQueryResult = Apollo.QueryResult<MaterialTypesQuery, MaterialTypesQueryVariables>;